import { Component, Input } from '@angular/core';
import { AvatarSize, Breakpoints } from '@yupma/ui-kit';

export enum SkeletonComponentEnum {
  DEFAULT = 'default',
  CONTACT_LIST = 'contact_list',
  CONTACT = 'contact',
  SEARCH = 'search',
  FIELDS = 'fields',
  ORGANISATION_LIST = 'organisation_list',
  USERS = 'users',
  DETAILS = 'details',
  HOME = 'home',
  HOME_SECTION = 'home_section',
  INVITE_SETUP = 'invite_setup',
  AUTOMATION_LIST = 'automation_list',
  WORKFLOW = 'workflow',
}

@Component({
  selector: 'app-skeleton-loader',
  templateUrl: './skeleton-loader.component.html',
  styleUrl: './skeleton-loader.component.scss'
})

export class SkeletonLoaderComponent {
  @Input() component: SkeletonComponentEnum = SkeletonComponentEnum.DEFAULT;
  avatarSizes = AvatarSize;
  lgArray = new Array(8).fill(0);
  mdArray = new Array(5).fill(0);
  smArray = new Array(3).fill(0);
  breakpoints = Breakpoints;
  isInsideBreakpoint: boolean = true;
  skeletonComponentEnums = SkeletonComponentEnum;

  updatedInsideBreakpoint(isInsideBreakpoint: boolean) {
    this.isInsideBreakpoint = isInsideBreakpoint;
  }
}
